import * as BABYLON from 'babylonjs';
import BasicComponent from './BasicComponent';
import MediaManager from '@/api/MediaManager';

class VideoSphere extends BasicComponent {
    getType() { return "VideoSphere"; }

    constructor( { id } = {} ) {
        super( { id });
        this.context= undefined;
        this.prefab = undefined;
        this.video = undefined;
    }

    construct( context, prefab ) {
        console.log("Construct VideoSphere");

        const base = super.construct( context, prefab ).getRootNode();
        
        const name = "SituationVideo_"+ prefab.getSphereVideoID();
        const panoramaVideo = MediaManager.getMedia(prefab.getSphereVideoID());

        const myVideoDome = new BABYLON.VideoDome(name, panoramaVideo.getURL(), { 
            resolution:32, 
            clickToPlay: false, 
            loop: false,
            autoPlay: context.enablePanoramaVideoAutoplay,
            poster:"",
            size: 400,  
            faceForward: false,
        }, window.scene);
        myVideoDome.parent = base;
       
        this.video = myVideoDome.videoTexture.video;
        this.prefab = prefab;
        this.context = context;

        // update runtimestate: update loaded data of video in %
        this.video.onprogress = function() {
            var bf = this.buffered;
            var loadedPercentage = bf.length > 0 ? (bf.end(bf.length-1) / this.duration) *100: 0;
            loadedPercentage = context.$browserDetect.isFirefox && loadedPercentage > 70 ? 100 : loadedPercentage; //Firefox wont trigger progress again when video completely loaded
            context.updateRuntimeState({id: prefab.getID(),percentageLoaded: loadedPercentage});
        }

        // update runtimestate: change currenTime when the panorama video currenttime changed
        // timeupdate event fires when the panorama video attribute currentTime changed
        this.video.ontimeupdate = () => {
            context.updateRuntimeState({id: this.prefab.getID(),currentTime: this.video.currentTime});
        };
        
        // update runtimestate: change duration when the panorama video meta data are loaded (meta data include duration of video)
        this.video.onloadedmetadata = () => {
            context.updateRuntimeState({id: this.prefab.getID(),duration: this.video.duration});
            context.setLoadingscreenVisible(false); //Disable loadingscreen when meta data is loaded to prevent white screen
        };
        
        // update runtimestate: change playstate of video to paused when video ended
        this.video.onended = () => {
            this.pause();
        };
        
        // update runtimestate: set playing state based on video autoplay
        context.updateRuntimeState({id: this.prefab.getID(),paused: !context.enablePanoramaVideoAutoplay}); 


        
        /** Edge cases **/ 
           
        // Chrome shows blackscreen as thumbnail -> happens when video is not autoplayed or browser stops autoplaying
        // quickly play and pause video to get first frame as thumbnail
        if(this.video.paused && context.$browserDetect.isChrome){
            console.log("VideoSphere: fixing Chrome thumbnail");

            // muted videos can be autoplayed
            // mute and play Video to get thumbnail, 
            this.video.muted = true;
            let promise = this.video.play();
            
            // After play is successful pause and unmute video again
            promise.then( ()=>{
                this.pause(); 
                this.video.muted = false;
                
                // Ensure autoplay after user interaction for chrome
                if(context.enablePanoramaVideoAutoplay){
                    console.log("VideoSphere: adding function to simulate Autoplay - Chrome");
                    window.scene.onPointerDown = () => {
                        this.play();
                        window.scene.onPointerDown  = undefined;
                    }
                }
            })
        }


        // if autoplay is enabled and video is paused the browser stopped autoplay -> happens when first situation contains a video and the video is not muted
        // Modern Browsers stop autoplay of videos with sound on when the user didnt interact with the document first
        // Runs when meta data is loaded because safari stops video when metacdata is loaded
        /* TODO: Display an Overlay to force the user to interact with the document first. With that we can get Autoplay with sound on */
        this.video.addEventListener("loadedmetadata",() => {
            if(this.video.paused && context.enablePanoramaVideoAutoplay){
                console.log("VideoSphere: adding function to simulate Autoplay");
                this.pause(); //Call pause again to update runtimestate
                window.scene.onPointerDown = () => {
                    this.play();
                    window.scene.onPointerDown  = undefined;
                }
            }
        });

        return base;
    }

    
    enable(){
        super.enable();
        if(this.context.enablePanoramaVideoAutoplay)
            this.play();       
    }

    disable(){
        super.disable();
        this.pause();
    }

    pause(){
        super.pause();
        this.video.pause();
        this.context.updateRuntimeState({id: this.prefab.getID(),paused: this.video.paused});  
    }

    play(){
        super.play();
        this.video.play();       
        this.context.updateRuntimeState({id: this.prefab.getID(),paused: this.video.paused});     
    }

    jumpToTimePosition(time){
        super.jumpToTimePosition(time);
        this.video.currentTime = time;
        this.context.updateRuntimeState({id: this.prefab.getID(),currentTime: time});  
    }

    changeVolume(volume){
        super.changeVolume(volume);
        this.video.volume = volume;
        this.video.muted = volume == 0;
        this.context.updateRuntimeState({id: this.prefab.getID(),volume: volume});        
    }

    update () {

    }
}

export default VideoSphere;

